import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import CloseIcon from "@mui/icons-material/Close";
import RestoreIcon from "@mui/icons-material/Restore";
import {
  Box,
  Collapse,
  Grid,
  List,
  ListItem,
  Modal,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  styled,
  tableCellClasses,
} from "@mui/material";
import Paper from "@mui/material/Paper";
import TableContainer from "@mui/material/TableContainer";
import { v4 as uuid } from "uuid";

import React, { useEffect, useState } from "react";
import { useMutation } from "react-query";
import { useHistory } from "react-router-dom";
import { GetSuppliersCreditHistoryResponse } from "../../models/report.model";
import { GetSupplierCreditHistory } from "../../services/report.service";
import ActivePlansTableSkeleton from "../skeletons/ActivePlansTableSkeleton";
import ActivePlansTable from "../table/ActivePlansTable";

interface SuppliersInfoProps {
  loanTemplateId: number | undefined;
  loanTemplateTitle: string | undefined;
  card: string | undefined;
  financialSupplier: string | undefined;
  loanRequestsCount: number | undefined;
  loanRequestsAmountRial: number | undefined;
  remainingCreditAmountRial: number | undefined;
  userProfitPercent: number | undefined;
  realProfitPercent: number | undefined;
  maximumAmountRial: number | undefined;
  expireDate: string | undefined;
  assignedLoansCount: number | undefined;
  assignedLoansAmountRial: number | undefined;
  settledLoansCount: number | undefined;
  settledLoansAmountRial: number | undefined;
  render: boolean;
}
const StyledTableCell = styled(TableCell)(() => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#EDEFEF",
    color: "#1D4A87",
    fontWeight: "700",
    fontSize: 14,
    textAlign: "right",
    marginBottom: "0.5rem",
    overflowX: "auto",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    textAlign: "right !important",
    overflowX: "auto",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(even)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",

  maxHeight: "70vh",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  overflow: "auto",
  overflowX: {
    xs: "auto",
    sm: "auto",
    md: "auto",
    lg: "hidden",
  },
  paddingRight: "3vh",
  paddingTop: "3vh",
  direction: "ltr",
  "&::-webkit-scrollbar": {
    width: 7,
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "#F9FAFC",
    border: "2px solid #DAE0E4",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#9AAFC4",
  },
};

const ActivePlansCardCmp = ({
  loanTemplateId,
  loanTemplateTitle,
  card,
  financialSupplier,
  loanRequestsCount,
  loanRequestsAmountRial,
  remainingCreditAmountRial,
  userProfitPercent,
  realProfitPercent,
  maximumAmountRial,
  expireDate,
  assignedLoansAmountRial,
  assignedLoansCount,
  settledLoansAmountRial,
  settledLoansCount,
  render,
}: SuppliersInfoProps) => {
  const [openCollapse, setOpenCollapse] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const history = useHistory<any>();
  const [supplierCreditHistory, setSupplierCreditHistory] = useState<
    GetSuppliersCreditHistoryResponse[]
  >();

  // const id =
  //   history.location.state !== undefined ? history.location.state.id : null;

  const id = localStorage.getItem("SUPPLIER_ID");

  const { mutate } = useMutation(GetSupplierCreditHistory, {
    onSuccess: (data: GetSuppliersCreditHistoryResponse[]) => {
      if (data) {
        setSupplierCreditHistory(data);
      }
    },
    onError: () => { },
  });

  const handleHistoryCredit = () => {
    setOpenModal(true);
  };

  useEffect(() => {
    if (id && loanTemplateId) {
      mutate({
        supplierId: Number(id),
        loanTemplateId: loanTemplateId,
      });
    }
  }, []);

  // useEffect(() => {
  //   if (id && loanTemplateId) {
  //     mutate({
  //       supplierId: Number(id),
  //       loanTemplateId: loanTemplateId,
  //     });
  //   }
  // }, []);

  const collapseClickHandler = () => {
    setOpenCollapse((prev) => !prev);
  };

  useEffect(() => { }, [render]);

  let sumOfLoans = assignedLoansCount! + settledLoansCount!;
  return (
    <>
      <List>
        <ListItem>
          <Grid container spacing={0}>
            <Grid xs={12} sm={12} md={12} lg={2} textAlign={"right"}>
              {card ? (
                <img
                  className="activePlansCardImg"
                  src={`data:image/png;base64,${card}`}
                  alt=""
                />
              ) : (
                <Skeleton
                  variant="rectangular"
                  width={140}
                  height={75}
                  animation="wave"
                  sx={{
                    // marginLeft: "0.5rem",
                    borderRadius: "5px",
                  }}
                ></Skeleton>
              )}
            </Grid>
            <Grid container spacing={0} xs={12} sm={12} md={12} lg={9}>
              <Grid xs={12} sm={12} md={12} lg={12} xl={12}>
                <Grid
                  container
                  alignItems={"center"}
                  justifyContent={{
                    xs: "center",
                    sm: "center",
                    md: "center",
                    lg: "space-between",
                  }}
                >
                  <Grid item xs={12} sm={12} md={6} lg={10} xl={10}>
                    <Typography
                      color={"#1D4A87"}
                      textAlign={{ xs: "center", lg: "start" }}
                      fontWeight={"bold"}
                      marginY={{
                        xs: "1rem",
                        sm: "1rem",
                        md: "1rem",
                        lg: "0",
                        xl: "0",
                      }}
                    >
                      {loanTemplateTitle}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={2} xl={2}>
                    <Typography
                      fontSize={"16px"}
                      color={"#1D4A87"}
                      textAlign={{
                        xs: "center",
                        sm: "center",
                        md: "center",
                        lg: "left",
                      }}
                      sx={{ cursor: "pointer" }}
                      onClick={handleHistoryCredit}
                      borderLeft={{ md: "none", lg: "1px solid #c1c7cb" }}
                      paddingLeft={"1.5rem"}
                    >
                      <RestoreIcon sx={{ marginLeft: "0.5rem" }}></RestoreIcon>
                      تاریخچه اعتبار
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              {/* <Grid xs={12} sm={12} md={0} lg={6} xl={8}></Grid> */}
              <Grid
                container
                spacing={0}
                justifyContent={{
                  xs: "center",
                  sm: "center",
                  md: "center",
                  lg: "space-between",
                }}
                alignItems={"center"}
                columns={15}
              >
                <Grid
                  xs={12}
                  sm={12}
                  md={6}
                  lg={2}
                  borderLeft={{ lg: "1px solid #c1c7cb", md: "none" }}
                  borderBottom={{ xs: "1px solid #c1c7cb", md: "none" }}
                  paddingX={".5rem"}
                >
                  <Typography
                    textAlign={"center"}
                    sx={{
                      backgroundColor: "#1D4A87",
                      color: "#fff",
                      padding: ".5rem",
                      borderRadius: ".5rem",
                    }}
                    marginY={{
                      xs: "1rem",
                      sm: "1rem",
                      md: "1rem",
                      lg: "0",
                      xl: "0",
                    }}
                  >
                    {/* تامین کننده مالی  */}
                    {financialSupplier}
                  </Typography>
                </Grid>
                <Grid
                  borderLeft={{ lg: "1px solid #c1c7cb", md: "none" }}
                  borderBottom={{ xs: "1px solid #c1c7cb", md: "none" }}
                  paddingX={".5rem"}
                  paddingY={{
                    xs: "1rem",
                    sm: "1rem",
                    md: "1rem",
                    lg: "0",
                    xl: "0",
                  }}
                  xs={12}
                  sm={12}
                  md={6}
                  lg={4}
                >
                  <Typography textAlign={"center"}>
                    {/* تعداد تسهیلات اعطا شده: <b>{loanRequestsCount}</b> */}
                    تعداد تسهیلات اعطا شده: <b>{sumOfLoans}</b>
                  </Typography>
                </Grid>
                <Grid
                  borderLeft={{ lg: "1px solid #c1c7cb", md: "none" }}
                  borderBottom={{ xs: "1px solid #c1c7cb", md: "none" }}
                  paddingX={{ lg: ".5rem", md: "0" }}
                  paddingY={{
                    xs: "1rem",
                    sm: "1rem",
                    md: "1rem",
                    lg: "0",
                    xl: "0",
                  }}
                  xs={12}
                  sm={12}
                  md={6}
                  lg={5}
                >
                  <Typography textAlign={"center"}>
                    مبلغ کل تسهیلات اعطا شده:{" "}
                    <b>{loanRequestsAmountRial?.toLocaleString("fa")}</b> ریال
                  </Typography>
                </Grid>
                <Grid
                  paddingX={".5rem"}
                  paddingY={{
                    xs: "1rem",
                    sm: "1rem",
                    md: "1rem",
                    lg: "0",
                    xl: "0",
                  }}
                  xs={12}
                  sm={12}
                  md={6}
                  lg={4}
                >
                  <Typography textAlign={"center"}>
                    اعتبار باقیمانده:{" "}
                    <b>{remainingCreditAmountRial?.toLocaleString("fa")}</b>{" "}
                    ریال
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid xs={12} sm={12} md={12} lg={1} alignSelf={"center"}>
              <Box
                textAlign={{ xs: "center", sm: "center", md: "center" }}
                display={{
                  xs: "none",
                  sm: "none",
                  md: "none",
                  lg: "block",
                  xl: "block",
                }}
                onClick={collapseClickHandler}
                sx={{ cursor: "pointer", transform: "translate(0px, -23px)" }}
              >
                {openCollapse ? (
                  <ArrowDropDownIcon fontSize="large"></ArrowDropDownIcon>
                ) : (
                  <ArrowLeftIcon fontSize="large"></ArrowLeftIcon>
                )}
              </Box>
              <Box
                textAlign={{ xs: "center", sm: "center", md: "center" }}
                display={{ md: "block", lg: "none", xl: "none" }}
                onClick={collapseClickHandler}
                sx={{ cursor: "pointer" }}
              >
                {openCollapse ? (
                  <ArrowDropUpIcon fontSize="large"></ArrowDropUpIcon>
                ) : (
                  <ArrowDropDownIcon></ArrowDropDownIcon>
                )}
              </Box>
            </Grid>
          </Grid>
        </ListItem>
        <ListItem>
          <Collapse
            in={openCollapse}
            unmountOnExit
            timeout="auto"
            sx={{ width: "100%" }}
          >
            <Box
              sx={{
                backgroundColor: "#F6F8F9",
                border: "2px solid #DAE0E4",
                borderRadius: ".5rem",
                paddingTop: "1rem",
              }}
            >
              <Grid
                container
                spacing={0}
                alignItems={"center"}
                justifyContent={"flex-start"}
              >
                <Grid item lg={2}></Grid>
                <Grid item lg={9}>
                  <Grid container columns={15}>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={6}
                      lg={2}
                      borderLeft={{
                        lg: "1px solid #c1c7cb",
                        // md: "1px solid #c1c7cb",
                        sm: "none",
                      }}
                      borderBottom={{ xs: "1px solid #c1c7cb", lg: "none" }}
                    //   paddingX={"1rem"}
                    >
                      <Typography
                        sx={{ padding: ".5rem", transform: "translateX(3vw)" }}
                        textAlign={"right"}
                        whiteSpace={"nowrap"}
                      >
                        سود اسمی تسهیلات: <b>{userProfitPercent}</b> %
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={6}
                      lg={4}
                      borderLeft={{
                        lg: "1px solid #c1c7cb",
                        // md: "1px solid #c1c7cb",
                        sm: "none",
                      }}
                      borderBottom={{ xs: "1px solid #c1c7cb", lg: "none" }}
                    //   paddingX={"1rem"}
                    >
                      <Typography
                        sx={{ padding: ".5rem" }}
                        textAlign={"center"}
                        whiteSpace={"nowrap"}
                      >
                        سود واقعی تسهیلات: <b>{realProfitPercent}</b> %
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={6}
                      lg={5}
                      borderLeft={{
                        lg: "1px solid #c1c7cb",
                        // md: "1px solid #c1c7cb",
                        sm: "none",
                      }}
                      borderBottom={{ xs: "1px solid #c1c7cb", md: "none" }}
                    //   paddingX={"1rem"}
                    >
                      <Typography
                        sx={{ padding: ".5rem" }}
                        textAlign={"center"}
                        whiteSpace={"nowrap"}
                      >
                        سقف تسهیلات:{" "}
                        <b>{maximumAmountRial?.toLocaleString("fa")}</b> ریال
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={6}
                      lg={4}
                      //   paddingX={"1rem"}
                      whiteSpace={"nowrap"}
                    >
                      <Typography
                        sx={{ padding: ".5rem" }}
                        textAlign={"center"}
                      >
                        تاریخ انقضا: <b>{expireDate}</b>
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                container
                justifyContent={"center"}
                sx={{ backgroundColor: "rgba(154,175,196,0.15)" }}
                paddingY={"1rem"}
                marginTop={"1rem"}
              >
                {/* <Grid item xs={1}></Grid> */}
                <Grid item xs={12}>
                  <Grid
                    container
                    justifyContent={"center"}
                    alignItems={"center"}
                    columns={13}
                  >
                    <Grid item lg={1}></Grid>
                    <Grid item xs={12} sm={12} md={6} lg={2} textAlign={"left"}>
                      <Typography color={"#1D4A87"} fontSize={"14px"}>
                        تعداد اعطا شده: <b>{assignedLoansCount}</b>
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={6}
                      lg={3}
                      textAlign={"center"}
                    >
                      <Typography color={"#1D4A87"} fontSize={"14px"}>
                        مجموع اعطا شده:{" "}
                        <b>{assignedLoansAmountRial?.toLocaleString("fa")}</b>{" "}
                        ریال
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={6}
                      lg={3}
                      textAlign={"center"}
                    >
                      <Typography color={"#1D4A87"} fontSize={"14px"}>
                        تعداد تسویه شده: <b>{settledLoansCount}</b>
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={6}
                      lg={3}
                      textAlign={"center"}
                    >
                      <Typography color={"#1D4A87"} fontSize={"14px"}>
                        مجموع تسویه شده:{" "}
                        <b>{settledLoansAmountRial?.toLocaleString("fa")}</b>{" "}
                        ریال
                      </Typography>
                    </Grid>
                    <Grid item lg={1}></Grid>
                  </Grid>
                </Grid>
                {/* <Grid item xs={1}></Grid> */}
              </Grid>
            </Box>
          </Collapse>
        </ListItem>
      </List>
      <div>
        <Modal
          open={openModal}
          onClose={() => setOpenModal(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Box position={"relative"}>
              <Typography
                onClick={() => setOpenModal(false)}
                component={"p"}
                color={"red"}
                position={"absolute"}
                top={0}
                left={0}
                sx={{ cursor: "pointer" }}
              >
                <CloseIcon></CloseIcon>
              </Typography>
            </Box>
            <Typography
              component={"p"}
              display={"block"}
              textAlign={"center"}
              fontWeight={"bold"}
              marginY={"2rem"}
              fontSize={"16px"}
            ></Typography>
            <Box sx={{ border: "1px solid #DAE0E4" }}>
              <TableContainer
                component={Paper}
                sx={{
                  direction: "rtl",
                  padding: "0.5rem",
                  // overflowX: "auto !important",
                  maxWidth: { xs: 300, sm: 500, md: "100%", lg: "100%" },
                  width: "100%",
                }}
              >
                {supplierCreditHistory ? (
                  <Table
                    sx={{ minWidth: { xs: 0, sm: 0, md: 700, lg: 900 } }}
                    aria-label="customized table"
                  >
                    <TableHead sx={{ outline: "1px solid #DAE0E4" }}>
                      <TableRow>
                        <StyledTableCell>کاربر درخواست کننده</StyledTableCell>
                        <StyledTableCell align="right">
                          تاریخ درخواست
                        </StyledTableCell>
                        <StyledTableCell align="right">
                          کاربر بررسی کننده
                        </StyledTableCell>
                        <StyledTableCell align="right">
                          تاریخ بررسی
                        </StyledTableCell>
                        <StyledTableCell align="right">وضعیت</StyledTableCell>
                        <StyledTableCell align="right">
                          مبلغ اعتبار (ریال)
                        </StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody sx={{ outline: "1px solid #DAE0E4" }}>
                      {supplierCreditHistory?.map((supplier) => (
                        <ActivePlansTable
                          key={uuid()}
                          amount={supplier.amount}
                          creditStatusTitle={supplier.creditStatusTitle}
                          requestDatePersian={supplier.requestDatePersian}
                          requestorUserTitle={supplier.requestorUserTitle}
                          reviewDatePersian={supplier.reviewDatePersian}
                          reviewerUserTitle={supplier.reviewerUserTitle}
                        />
                      ))}
                    </TableBody>
                    <Box style={{ height: "0.5rem" }}></Box>
                  </Table>
                ) : (
                  <ActivePlansTableSkeleton rowsNum={3} />
                )}
              </TableContainer>
            </Box>
          </Box>
        </Modal>
      </div>
    </>
  );
};

export default ActivePlansCardCmp;
